import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Typography } from "@mui/material";
import { ConnectedAppsKeys } from "@features/ConnectedApps/app-connection-helpers";
import { getAppIcon } from "@features/ConnectedApps/app-connection-helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  max-height: 100vh;
  padding: 2rem;
  @supports (height: 100dvh) {
    height: 100dvh;
    max-height: 100dvh;
  }
  text-align: center;
  background-color: ${(p) => p.theme.colors.background};
`;

const AppIconContainer = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  height: 4.5rem;

  h1 {
    font-size: 4.5rem;
  }

  img {
    width: auto;
    height: 100%;
    max-height: 4.5rem;
  }
`;

export const AppConnectionMessage = () => {
  const { appId } = useParams<{ appId: string }>();
  const [hasWindowOpener, setHasWindowOpener] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!window.opener) {
      navigate("/account");
      return;
    }
    const closeWindowTimeout = setTimeout(() => {
      window.close();
    }, 10000);
    setHasWindowOpener(true);

    return () => {
      clearTimeout(closeWindowTimeout);
    };
  }, [navigate]);

  if (!hasWindowOpener) return <p>Redirecting...</p>;

  return (
    <Container>
      <AppIconContainer>
        {getAppIcon(appId as ConnectedAppsKeys)}
      </AppIconContainer>
      <Typography variant="h5" fontWeight={600}>
        You&apos;re all set!
      </Typography>
      <Typography>
        Your account has been connected. Features requiring this integration are
        now enabled.
      </Typography>
      <Typography variant="body2" mt={1}>
        This window will close automatically, or you can close it now.
      </Typography>
    </Container>
  );
};
